import { render, staticRenderFns } from "./BtnInserirAditivo.vue?vue&type=template&id=0813c98e"
import script from "./BtnInserirAditivo.vue?vue&type=script&lang=js"
export * from "./BtnInserirAditivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports